import { render } from "./MenuMediasTableMedias.vue?vue&type=template&id=0348f026&scoped=true"
import script from "./MenuMediasTableMedias.vue?vue&type=script&lang=js"
export * from "./MenuMediasTableMedias.vue?vue&type=script&lang=js"

import "./MenuMediasTableMedias.vue?vue&type=style&index=0&id=0348f026&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0348f026"

export default script